import React, {useEffect} from 'react';
import { Link } from 'gatsby';

import { formatDate, getImageUrlFromFilename } from '@vitl-services/services/format';
import { useImage } from '@hooks/useImage';
import { IImage } from '@vitl-services/interfaces/image';

import * as styles from './blog-article-preview.module.scss';

interface IProps {
  isEven: boolean;
  title: string;
  datePublished?: number | null;
  preview: string;
  readMoreLabel: string;
  heroImage: IImage;
  path: string;
  author: string;
  isFirst: boolean;
}

const BlogArticlePreview: React.FC<IProps> = ({
  title,
  path,
  datePublished,
  preview = '',
  readMoreLabel,
  heroImage,
  author,
  isFirst,
}) => {
  const image = heroImage?.filename_disk;
  const truncatedPreview = preview.slice(0, 150);
  const logoHeader = useImage(['logo_header.svg']);

  return (
    <div
      className={isFirst ? styles.firstPostPreview : styles.postPreview}
      data-testid={isFirst ? 'first-blog' : 'blog'}
    >
      <Link className={styles.buttonLink} to={path}>
        <div
          className={isFirst ? styles.firstImagePreview : styles.imagePreview}
          style={{
            backgroundImage: `url(${
              getImageUrlFromFilename(image) +
              (isFirst ? '?w=800&h=500' : '?crop=true&w=400&h=300')
            }), url(${logoHeader})`,
          }}
        ></div>
      </Link>
      <div className={isFirst ? styles.firstTextPreview : styles.textPreview}>
        <Link className={styles.buttonLink} to={path}>
          <h2 className={styles.h2}>{title}</h2>
        </Link>
        <p className={styles.preview}>
          {isFirst ? preview : `${truncatedPreview} ...`}
        </p>
        <div className={isFirst ? styles.firstDate : styles.date}>
          {author && author}
          {author && datePublished ? (
            <span className={styles.dateDivider}> / </span>
          ) : (
            ''
          )}
          {datePublished && `${formatDate(datePublished)}`}
        </div>
      </div>
    </div>
  );
};

export default BlogArticlePreview;
